import {__} from '@wordpress/i18n'
import { useState, useEffect } from '@wordpress/element'
import {
  Placeholder,
  ButtonGroup,
  Button,
  Dashicon,
  Modal,
  TabPanel,
  TabList,
  Tab,
  PanelRow,
  PanelColumn,
  RangeControl,
  BaseControl
} from "@wordpress/components";
import InspectorResponsiveLabel from '../inspector-responsive-label';


const InspectorSelectButton = props => {
  const { label, options, value, onChange, iconButton } = props;
  
  return (
    <BaseControl
    label={label??"Default"}
    id="alpha-accordion-type"
>
    <ButtonGroup id="alpha-accordion-type" className="flex w-full gap-0">
        {options?.map(
            (item, key) => (
                <Button
                    className="flex-1 text-center justify-center"
                    key={key}
                    // isLarge
                    isSecondary={
                      value !==
                        item.value
                    }
                    isPrimary={
                      value ===
                        item.value
                    }
                    onClick={() =>
                      onChange(item.value)
                    }
                >
                    {iconButton?<Dashicon icon={item.iconName}></Dashicon>:item.label}
                </Button>
            )
        )}
    </ButtonGroup>
  </BaseControl>                 
  );
}

export default InspectorSelectButton;